import { AppContent } from '@dtx-company/inter-app/src/redux/slices/app-content-slice'
import { fetchFooterData } from '../../../components/layout/footer/data'
import { fetchMarketingNavData } from '../../../components/layout/header/data'

export async function getInitialAppContent(): Promise<AppContent> {
  const [footer, marketingNav] = await Promise.all([fetchFooterData(), fetchMarketingNavData()])
  return {
    footer,
    marketingNav
  }
}
//
